/* eslint-disable no-await-in-loop */
/* eslint-disable no-undef */
/* eslint-disable no-magic-numbers */
/* global Autocomplete */

// Constants
const STOREFRONT_ACCESS_TOKEN = '12c06f5df534be0887c5ecf8504fef97';
const GRAPHQL_URL = 'https://one-project-shop.myshopify.com/api/2023-07/graphql.json';
// Elements
const schoolsSelect = document.getElementById('school');

const cityAutocomplate = new Autocomplete('city', {
	onSearch: ({ currentValue }) => filterResults(window.collections, currentValue),
	onResults: ({ matches, template }) => {
		return matches === 0
			? template
			: matches.map((el) => ` <li data-handle=${el.handle}>${el.title}</li>`).join('');
	},
	noResults: ({ element, template }) =>
		template(`<li>לא נמצאו תוצאות עבור: "${element.value}"</li>`),
	clearButton: true,
	selectFirst: false,
	onReset: clearSchools,
	showAllValues: true,
	cache: true,
	// This function simulates clicking the desired city from the list of cities that we get in the results and accordingly shows us the field of schools from that city
	onSubmit: ({ object }) => {
		window.city = object.handle;
		const schoolsList = document.getElementById('auto-school-results');
		if (schoolsList) {
			schoolsList.innerHTML = '';
		}
		document.getElementById('schools').style.display = 'block';
	},
});
new Autocomplete('school', {
	onSearch: ({ currentValue }) => getSchools(currentValue, window.city),
	onResults: ({ matches, template }) => {
		document.getElementById('school').dataset.city = window.city;
		return matches === 0
			? template
			: matches.map((el) => ` <li data-school=${el.id}>${el.title}</li>`).join('');
	},
	noResults: ({ element, template }) =>
		template(`<li>לא נמצאו תוצאות עבור: "${element.value}"</li>`),
	clearButton: true,
	selectFirst: false,
	onReset: clearSchools,
	onSubmit: pickSchool,
	showAllValues: true,
});

document.addEventListener('DOMContentLoaded', () => {
	const { schoolCityValue, schoolObject, schoolElementValue } = checkIfCookieExist();
	if (schoolCityValue && schoolObject && schoolElementValue) {
		showSchoolElementAndSetCookie({ schoolCityValue, schoolObject, schoolElementValue });
	}
	const radios = document.querySelectorAll('input[name="logo-color"]');
	radios.forEach((radio) => {
		radio.addEventListener('click', () => {
			setLogoVariant(radio);
			setColorSymbol(radio);
		});
	});

	// Remove label after selected color
	const selectColorCheckboxLabel = document.querySelectorAll('.selected-color');
	selectColorCheckboxLabel.forEach((selectedColor) => {
		selectedColor.addEventListener('click', () => {
			removeSelectColorAlert();
		});
	});
});

document.getElementById('showLogoPicker').addEventListener('change', handleCheckboxLogoPicker);

// Retrieve the list of all the schools collections
async function getAllCollections() {
	// Check for "cached" results
	if (window.collections) {
		return window.collections;
	}

	const GRAPHQL_CREATE = (cursor = null) => {
		cursor = cursor ? `"${cursor}"` : null;
		return {
			async: true,
			crossDomain: true,
			method: 'POST',
			headers: {
				'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
				'Content-Type': 'application/graphql',
			},
			body: `{
                    collections(first: 250, after: ${cursor}) {
                        pageInfo{
                            hasNextPage
                        }
                        edges {
                            cursor
                            node {
                                title
                                handle
                            }
                        }
                    }
                }`,
		};
	};
	let nextPage = true;
	let cursor = null;
	let collections = [];
	// Loop through all the pages to get ALL of the collections
	while (nextPage) {
		const response = await fetch(GRAPHQL_URL, GRAPHQL_CREATE(cursor));
		const resJson = await response.json();
		const batch = resJson.data.collections;
		collections = collections.concat(batch.edges);
		cursor = batch.edges[batch.edges.length - 1].cursor; // Last cursor
		nextPage = batch.pageInfo.hasNextPage;
	}
	// Sanitize the data
	collections = collections.map((collection) => {
		return {
			title: collection.node.title,
			handle: collection.node.handle,
		};
	});
	// "Cache" the results
	window.collections = collections;
	return collections;
}

// Retrieve the list of schools from the selected city
async function getSchools(query, city) {
	// Check for "cached" results
	if (window[city]) {
		return filterResults(window[city], query);
	}

	const GRAPHQL_CREATE = (cursor = null) => {
		cursor = cursor ? `"${cursor}"` : null;
		return {
			async: true,
			crossDomain: true,
			method: 'POST',
			headers: {
				'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
				'Content-Type': 'application/graphql',
			},
			body: `{
                    collectionByHandle(handle: "${city}") {
                        products(first: 20, after: ${cursor}) {
                        pageInfo{
                            hasNextPage
                        }
                        edges {
                            cursor
                            node {
                            title
                            id
                            featuredImage{
                                src
                            }
                            variants(first: 3) {
                                edges {
                                node {
                                    id
                                    barcode
                                    title
                                    quantityAvailable
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                }`,
		};
	};
	let nextPage = true;
	let cursor = null;
	let schools = [];
	// Loop through all the pages to get ALL of the collections
	while (nextPage) {
		const response = await fetch(GRAPHQL_URL, GRAPHQL_CREATE(cursor));
		const resJson = await response.json();
		const data = resJson.data.collectionByHandle.products;
		schools = schools.concat(data.edges);
		cursor = data.edges[data.edges.length - 1].cursor; // Last cursor
		nextPage = data.pageInfo.hasNextPage;
	}
	// Sanitize the data
	schools = schools.map((school) => {
		node = school.node;
		return {
			title: node.title.replaceAll('"', '"'),
			id: gql2rest(node.id),
			image: node.featuredImage?.src,
			logos: node.variants.edges.map((variant) => {
				variantNode = variant.node;
				return {
					title: variantNode.title.replaceAll('"', '"'),
					id: gql2rest(variantNode.id),
					barcode: variantNode.barcode,
					quantity: variantNode.quantityAvailable,
				};
			}),
		};
	});
	// Save it to cache
	window[city] = schools;
	return filterResults(schools, query);
}

// Convert graphql ID to rest ID
function gql2rest(gqlId) {
	const tmp = gqlId.split('/');
	return parseInt(tmp[tmp.length - 1]);
}

// Helper functions
function removeSelectColorAlert() {
	if (document.querySelector('.most-select-color')) {
		document.querySelector('.most-select-color').style.display = 'none';
	}
}

// Filter search results
function filterResults(results, query) {
	return results?.filter((res) => res.title.includes(query));
}

// Change selected logo variant
function setLogoVariant(radioButton) {
	const { barcode } = radioButton.dataset;
	const schoolIdProp = document.getElementById('schoolId');
	if (schoolIdProp) {
		schoolIdProp.value = barcode;
	}
	setLineItemProperties({
		id: 'schoolId',
		name: 'properties[_logoBarcode]',
		value: barcode,
	});
}
// Set the color symbol from school
function setColorSymbol(radioButton) {
	const { color } = radioButton.dataset;
	const schoolSymbol = document.getElementById('schoolSymbol');
	if (schoolSymbol) {
		schoolSymbol.value = color;
		return;
	}
	setLineItemProperties({
		id: 'schoolSymbol',
		name: 'properties[צבע סמל]',
		value: color,
	});
}
// Set image Properties
function setImageProperty(src) {
	const schoolThumbProp = document.getElementById('logoImage');
	if (schoolThumbProp) {
		schoolThumbProp.value = src;
		return;
	}
	setLineItemProperties({
		id: 'logoImage',
		name: 'properties[_logoImage]',
		value: src,
	});
}

// Set school logo image on the form
function changeSchoolLogoImage(school) {
	const imgEL = document.getElementById('schoolLogoImg');
	imgEL.style.display = 'block';
	imgEL.src = school.image;
	imgEL.alt = school.title;
}

// Set logo color picker
function setLogoColorPicker(school) {
	const addToCartBtn = document.getElementById('AddToCart');
	// Check if any in stock
	const inStock = school.logos.filter((logo) => logo.quantity > 0).length;
	if (!inStock) {
		addToCartBtn.classList.add('button--ternary');
		addToCartBtn.disabled = true;
		addToCartBtn.innerText = 'אזל מהמלאי';
		return false;
	}
	addToCartBtn.classList.remove('button--ternary');
	addToCartBtn.disabled = false;
	addToCartBtn.innerText = 'הוסף לסל';
	// Handle the radio button logic
	const radios = document.querySelectorAll('input[name="logo-color"]');
	radios.forEach((radio, index) => {
		const radioContainer = radio.parentElement;
		radioContainer.style.display = 'none';
		const logo = school.logos[index];
		if (!logo) {
			return;
		}
		if (logo.quantity < 1) {
			radioContainer.classList.add('is-disabled');
			radio.disabled = true;
			radio.checked = false;
		}
		radio.setAttribute('data-barcode', school.logos[index].barcode);
		updateLogoColor({ logo, radio, radioContainer });
	});
	return true;
}

function updateLogoColor({ logo, radio, radioContainer }) {
	// Check if the logo quantity is greater than 0
	// eslint-disable-next-line no-magic-numbers
	if (logo.quantity > 0) {
		// If logo quantity is greater than 0, enable the radio button and remove the 'is-disabled' class from the radio container
		radioContainer.classList.remove('is-disabled');
		radio.removeAttribute('disabled');
	}

	// Convert the logo title to uppercase
	const title = logo.title.toUpperCase();
	const colorMap = {
		BLACK: { colorClass: 'BLACK', index: 1, text: 'Black' },
		WHITE: { colorClass: 'WHITE', index: 0, text: 'White' },
		COLOR: { colorClass: 'COLOR', index: 2, text: 'Color' },
	};

	// Get the selected color from the colorMap based on the logo title
	const selectedColor = colorMap[title];

	if (selectedColor) {
		// If the selected color exists in the colorMap, update the UI accordingly
		const { colorClass, text } = selectedColor;

		// Get the target element (e.g., a div) with the ID based on the lowercase logo title
		const targetElement = document.getElementById(`${title.toLowerCase()}Logo`);

		// Remove the color class from all sibling elements of the radio button
		Object.values(colorMap).forEach((color) => {
			const { colorClass } = color;
			radio.nextElementSibling.classList.remove(colorClass);
		});

		// Set the inner text of the target element to display the selected color's text
		targetElement.innerText = text;

		// Add the selected color's class to the sibling element of the radio button
		radio.nextElementSibling.classList.add(colorClass);

		// Display the radio container (it might have been hidden before)
		radioContainer.style.display = 'block';
	}
}

// Remove any choosen school logos if unchecked
function clearSchools() {
	// Clear properties
	[
		document.getElementById('schoolId'),
		document.getElementById('schoolName'),
		document.getElementById('logoImage'),
	].forEach((input) => input?.remove());

	// Clear input select color value
	document.querySelectorAll('[name="logo-color"]').forEach((input) => {
		input.value = '';
		input.removeAttribute('disabled');
	});

	// Clear image
	const imgEL = document.getElementById('schoolLogoImg');
	imgEL.style.display = 'none';
	imgEL.src = '';
	imgEL.alt = '';

	// Clear picks
	[document.getElementById('city'), document.getElementById('school')].forEach(
		(el) => (el.value = '')
	);

	// Hide schools picker
	document.getElementById('schools').style.display = 'none';

	// Hide variants
	document.querySelector('.logo-colors-wrapper .block-swatch-list').style.display = 'none';

	// Set auto focus
	window.setTimeout(() => document.getElementById('city').focus(), 0);

	resetAllRadioButton();

	// Clear red text reminder to select logo color
	removeSelectColorAlert();
}

// This fucntion reset all color button
function resetAllRadioButton() {
	document.querySelectorAll('[name="logo-color"]').forEach((input) => {
		input.value = '';
		input.checked = false;
	});
}
// Check if logo color was selected
function selectColorValid(event) {
	const checkedBlockArray = document.querySelectorAll('.logo-colors-wrapper .block-swatch__radio');
	let colorSelected = false;
	checkedBlockArray.forEach((checkBlock) => {
		if (checkBlock.checked) {
			colorSelected = true;
		}
	});
	if (!colorSelected) {
		event.preventDefault();
		document.querySelector('.most-select-color').style.display = 'block';
		return;
	}
	removeSelectColorAlert();
}

async function handleCheckboxLogoPicker(e) {
	const checked = e.target ? e.target.checked : e.checked;
	const buyBtn = document.getElementById('AddToCart');
	const logoPickerWrapper = document.getElementById('logoPicker');
	logoPickerWrapper.style.maxHeight = checked ? '500px' : 0;
	logoPickerWrapper.style.overflow = checked ? 'unset' : 'hidden';
	// Toggle the logo picker wrapper based on the checkbox state
	if (checked) {
		// If the checkbox is checked, fetch all collections and enable the "buy" button event listener
		window.collections = await getAllCollections();
		buyBtn.addEventListener('click', selectColorValid, true);
		togglePaymentButtonDisplay();
		return;
	}
	removeSchoolFromCookies();
	clearSchools();
	buyBtn.removeEventListener('click', selectColorValid, true);
	togglePaymentButtonDisplay();
}

function togglePaymentButtonDisplay() {
	const buttonElement = document.querySelector('[data-shopify=payment-button]');
	if (buttonElement) {
		buttonElement.style.display = buttonElement.style.display === 'none' ? 'block' : 'none';
	}
}

// Change product property once a school is picked
async function pickSchool({ element, object }) {
	const { city } = element.dataset;
	const schools = await getSchools('', city);
	const selectedSchool = schools.filter((school) => school.title === object.title)[0];
	if (!selectedSchool) {
		return clearSchools();
	}
	// Handle logo image change
	changeSchoolLogoImage(selectedSchool);
	// Handle variant id property
	const inventoryStatus = setLogoColorPicker(selectedSchool);
	// If not in stock don't go on
	if (!inventoryStatus) {
		return;
	}

	resetAllRadioButton();

	// Handle school property
	setImageProperty(selectedSchool.image);
	const schoolNameProp = document.getElementById('schoolName');
	const schoolCity = document.getElementById('city').value;
	setSchoolLogoCookies({ element, object: { handle: city, title: object.title } });
	const schoolNameAndCity = selectedSchool.title + ' / ' + schoolCity;
	if (schoolNameProp) {
		schoolNameProp.value = schoolNameAndCity;
	} else {
		setLineItemProperties({
			id: 'schoolName',
			name: 'properties[בית-ספר]',
			value: schoolNameAndCity,
		});
	}
	// Show color picker
	document.getElementById('logosColors').style.display = 'flex';
}
// This fucntion get  element, id, name, value and set into the form
function setLineItemProperties({ id, name, value }) {
	const productForm = schoolsSelect.closest('.product-form').querySelector('form');
	element = document.createElement('input');
	element.id = id;
	element.name = name;
	element.value = value;
	element.type = 'hidden';
	productForm.prepend(element);
}
// In this fucntion we save the data from school logo in cookies
function setSchoolLogoCookies({ element, object }) {
	const logoSchoolContainer = document.querySelector('.logo-picker-container');
	const schoolCity = logoSchoolContainer.querySelector('input[name="schoolcity"]').value;
	const cookies = [
		{ name: 'schoolCity', value: schoolCity, daysToExpire: 7 },
		{ name: 'schoolObject', value: object, daysToExpire: 7 },
		{ name: 'schoolElement', value: element.outerHTML, daysToExpire: 7 },
	];

	cookies.forEach((cookie) => {
		const { name, value, daysToExpire } = cookie;
		const expirationDate = new Date();

		expirationDate.setDate(expirationDate.getDate() + daysToExpire);
		document.cookie = `${name}=${encodeURIComponent(
			JSON.stringify(value)
		)}; expires=${expirationDate.toUTCString()}; path=/`;
	});
}

function removeSchoolFromCookies() {
	const cookiesToRemove = ['schoolCity', 'schoolObject', 'schoolElement'];
	cookiesToRemove.forEach((cookieName) => {
		const expirationDate = new Date();
		expirationDate.setDate(expirationDate.getDate() - 1);
		document.cookie = `${cookieName}=; expires=${expirationDate.toUTCString()}; path=/`;
	});
}
// This fucntion check if cookie exist
function checkIfCookieExist() {
	const schoolCityValue = getCookie('schoolCity');
	const schoolObject = getCookie('schoolObject');
	const schoolElementValue = getCookie('schoolElement');
	return { schoolCityValue, schoolObject, schoolElementValue };
}

// In this function we get the cookie
function getCookie(name) {
	const cookieArray = document.cookie.split(';');
	for (let i = 0; i < cookieArray.length; i++) {
		const cookie = cookieArray[i].trim();
		if (cookie.startsWith(name + '=')) {
			const value = decodeURIComponent(cookie.substring(name.length + 1));
			return JSON.parse(value);
		}
	}
	return null; // Return null if the cookie is not found
}

// In this function we create the school elemnt and set data from cookies
function showSchoolElementAndSetCookie({ schoolCityValue, schoolObject, schoolElementValue }) {
	const logoCheckbox = document.getElementById('showLogoPicker');
	logoCheckbox.checked = true;
	handleCheckboxLogoPicker(logoCheckbox);
	const schoolCity = document.getElementById('city');
	const schoolName = document.getElementById('school');
	// In this line we pass the information we get from the cookie inside the cityAutocomplate method, and in cityAutocomplate.vt we reach into the onSubmit and enter the handle inside the object.
	cityAutocomplate.vt({ object: schoolObject });
	schoolCity.value = schoolCityValue;
	const htmlDomParser = new DOMParser();
	const schoolElement = htmlDomParser.parseFromString(schoolElementValue, 'text/html');
	const element = schoolElement.getElementById('school');
	pickSchool({ element: element, object: schoolObject });
	schoolName.value = schoolObject.title;
	const logoPicker = document.getElementById('logoPicker');
	const schools = document.getElementById('schools');
	schools.style.display = 'block';
	logoPicker.style.overflow = 'unset';
	logoPicker.style.maxHeight = '500px';
	const buyBtn = document.getElementById('AddToCart');
	buyBtn.addEventListener('click', selectColorValid, true);
}
